var TimeFieldFormat;
(function (TimeFieldFormat) {
    TimeFieldFormat["DEFAULT"] = "HH:mm";
    TimeFieldFormat["WITH_PERIOD"] = "hh:mm A";
})(TimeFieldFormat || (TimeFieldFormat = {}));
var TimeFieldSelectionMode;
(function (TimeFieldSelectionMode) {
    TimeFieldSelectionMode["FREE"] = "free";
    TimeFieldSelectionMode["PREDEFINED"] = "predefined";
})(TimeFieldSelectionMode || (TimeFieldSelectionMode = {}));
var TimeFieldMode;
(function (TimeFieldMode) {
    TimeFieldMode["TWELVE_HOURS"] = "12";
    TimeFieldMode["TWENTY_FOUR_HOURS"] = "24";
})(TimeFieldMode || (TimeFieldMode = {}));
var TimeFieldPickerIndex;
(function (TimeFieldPickerIndex) {
    TimeFieldPickerIndex[TimeFieldPickerIndex["FROM"] = 0] = "FROM";
    TimeFieldPickerIndex[TimeFieldPickerIndex["UNTIL"] = 1] = "UNTIL";
})(TimeFieldPickerIndex || (TimeFieldPickerIndex = {}));
var TimeFieldPeriod;
(function (TimeFieldPeriod) {
    TimeFieldPeriod["AM"] = "AM";
    TimeFieldPeriod["PM"] = "PM";
})(TimeFieldPeriod || (TimeFieldPeriod = {}));
var TimeFieldValueType;
(function (TimeFieldValueType) {
    TimeFieldValueType["HOUR"] = "hour";
    TimeFieldValueType["MINUTE"] = "minute";
    TimeFieldValueType["TIME_ZONE"] = "timeZone";
})(TimeFieldValueType || (TimeFieldValueType = {}));
export { TimeFieldFormat, TimeFieldSelectionMode, TimeFieldMode, TimeFieldPickerIndex, TimeFieldPeriod, TimeFieldValueType, };
//# sourceMappingURL=time-field-constants.js.map